import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  text: {
    margin: 0,
  },
});

export default useStyles;
